module.exports = __webpack_public_path__ + "img/Piston-and-Wrench-Tattoo-Designs-by-gladeyery-510x510.jpg";